/*!

 =========================================================
 * Vue Paper Dashboard - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import store from './store';
import PaperDashboard from "./plugins/paperDashboard";
Vue.use(Antd);
Vue.use(PaperDashboard);
Vue.config.devtools = true

import i18n from './i18n'

/* eslint-disable no-new */
new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount("#app");
